var render = function render(){var _vm=this,_c=_vm._self._c;return _c('new-mass-actions-panel',{attrs:{"actions":_vm.preparedActions,"inline-count":_vm.inlineCount,"small":_vm.small}})
}
var staticRenderFns = []

export { render, staticRenderFns }